(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};
      const slideHost = this.closest('.grid__item');
      const desktopSlides = swiperOptions.slidesPerViewDesktop || 2;
      const desktopGap = swiperOptions.spaceBetweenDesktop || 12;

      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        slidesPerView: 'auto',
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        resistanceRatio: 0.72,
        slidesOffsetAfter: 0,
        navigation: {
          nextEl:
            slideHost?.querySelector(
              '.section__slider-buttons--head .swiper-button--next'
            ) || slideHost?.querySelector('.swiper-button--next'),
          prevEl:
            slideHost?.querySelector(
              '.section__slider-buttons--head .swiper-button--prev'
            ) || slideHost?.querySelector('.swiper-button--prev')
        },
        breakpoints: {
          750: {
            slidesPerView: desktopSlides,
            spaceBetween: desktopGap,
            slidesOffsetAfter: 0
          },
          1100: {
            slidesPerView: desktopSlides,
            spaceBetween: desktopGap,
            slidesOffsetAfter: 0
          }
        }
      };
    }

    initSlider() {
      super.initSlider();
      this.parentElement.classList.remove('hidden');
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
})();
